import { Controller } from "@hotwired/stimulus"
import { screenCaptureLoop } from "../screen_capture/capture_loop"
import { screenCaptureCompletion } from "../screen_capture/completion"
import { screenCaptureLifecycle } from "../screen_capture/lifecycle"
import { screenCapturePresenter } from "../screen_capture/presenter"
import { screenCaptureSession } from "../screen_capture/session"

// Stimulus fallbacks when a template omits data-screen-capture-*-value.
// Canonical capture policy lives on AiValidation::ScreenShare::LlmSnapshotNormalizer.
class ScreenCaptureController extends Controller {
  static targets = [
    "status", "video", "canvas", "startButton",
    "hiddenComplete", "hiddenMatches", "hiddenConfidence", "hiddenReason",
    "hiddenVisibleName", "hiddenVisibleMembershipId", "hiddenVisibleTier",
    "hiddenCapturesJson", "hiddenSessionId", "validationGate",
    "captureCard", "successGif",
    "openValidationButton", "openValidationLabel",
    "substepOpen", "substepOpenBadge", "substepOpenHint",
    "substepShare", "substepShareBadge", "substepShareHint",
    "interruptionNotice", "completionDialog"
  ]

  static values = {
    analyzeUrl: String,
    wizardMode: { type: Boolean, default: false },
    wizardUrl: String,
    intervalMs: { type: Number, default: 2000 },
    minimumDurationMs: { type: Number, default: 10000 },
    minimumConfidence: { type: Number, default: 95 },
    finalConfirmationFrames: { type: Number, default: 1 },
    maxFrames: { type: Number, default: 60 },
    sessionsUrl: String,
    campaignId: String,
    completionNotificationTitle: String,
    completionNotificationBody: String,
    evidenceLimit: { type: Number, default: 12 },
    i18n: { type: Object, default: {} }
  }

  connect() {
    this.stream = null
    this.timer = null
    this.frameCount = 0
    this.captureStartedAt = null
    this.awaitingFinalConfirmationFrame = false
    this.finalConfirmationFramesCaptured = 0
    this.running = false
    this.verifiedWizardFiles = []
    this.capturedState = this.emptyCapturedState()
    this.session = null
    this.validationWindow = null
    this.previousFrameDataUrl = null
    this.stoppingStream = false
    this.renderCapturedState()
    this.applyScreenShareEnvironmentHints()
    this.applyShareButtonGate()
  }

  disconnect() {
    this.teardown()
  }
}

Object.assign(
  ScreenCaptureController.prototype,
  screenCaptureSession,
  screenCaptureLifecycle,
  screenCaptureLoop,
  screenCaptureCompletion,
  screenCapturePresenter
)

export default ScreenCaptureController
